<template>
  <div
    v-if="billet.sessions && billet.sessions.length"
    class="flex flex-wrap col-12 h6n my2"
  >
    <div class="flex col-12 items-center pointer" @click="toggleCollapsible()">
      <div class="left-align col-10 inline-block pl1 bold">
        Prochains créneaux réservés :
      </div>
      <div class="col-2 no-box inline-block justify-end">
        <div
          tabindex="0"
          role="button"
          class="py1 no-box px1 flex xs-justify-center justify-end items-center"
        >
          <i
            class="h3n icon icon-angle-down-icon bold"
            :class="{
              'icon-angle-up-icon': isOpen,
            }"
          ></i>
        </div>
      </div>
    </div>
    <div :id="sessionId" class="flex overflow-hidden collapsible col-12">
      <div class="flex flex-column col-12 content">
        <div :id="sessionContentId" class="flex flex-wrap col-12">
          <div
            v-for="session in billet.sessions"
            :key="session"
            class="flex flex-grow items-center h7n col-12 pl1 my1"
          >
            <div class="flex flex-wrap col-9 h8n">
              <div class="flex col-12 caps">{{ session.type }}</div>
              <div class="flex col-12">
                {{ session.startDate }} - {{ session.startTime }} à
                {{ session.endTime }}
              </div>
            </div>
            <div
              class="flex flex-wrap full-height items-center justify-end pr1 col-3"
            >
              <span
                v-if="session.isCancelable"
                :class="[
                  'flex items-center full-height btn-reserve white-color black-bg py0 px1 pointer h6n',
                ]"
                @click="
                  cancel({
                    ...session,
                    participant_uuid: billet.customer.uuid,
                  })
                "
              >
                Annuler
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, ref } from "vue";

const props = defineProps({
  billet: {
    type: Object,
  },
  extraId: {
    type: String,
  },
});

const cancel = inject("cancel");
const isOpen = ref(false);
const sessionId = ref(`sessions-${props.billet.qrcode}-${props.extraId}`);
const sessionContentId = ref(
  `sessions-content-${props.billet.qrcode}-${props.extraId}`
);

// Methods
const toggleCollapsible = (forceOpen = false) => {
  const element = document.getElementById(sessionId.value);
  const content = document.getElementById(sessionContentId.value);
  if (isOpen.value && !forceOpen) {
    element.style.height = "0px";
  } else {
    element.style.height = `${content.offsetHeight}px`;
  }

  isOpen.value = forceOpen || !isOpen.value;
};

// Expose to template and parent components
defineExpose({
  toggleCollapsible,
  cancel,
  isOpen,
});
</script>

<style scoped>
.collapsible {
  height: 0px;
  transition: all 0.3s linear;
}

.content {
  min-height: 40px;
}
</style>
